import styled from 'styled-components';
export const Button = styled.a `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
`;
export const Title = styled.p `
    color: rgb(255, 255, 255);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.12px;
    margin: 0;

    &:hover {
        text-decoration: underline;
        text-decoration-color: white;
    }
`;
//# sourceMappingURL=index.js.map